// Mobile search shortcuts: governorate (+ delegation when the place is not a governorate).
export const POPULAR_DESTINATIONS = [
  { label: "Hammamet", city: "Nabeul", delegation: "Hammamet" },
  { label: "Sousse", city: "Sousse" },
  { label: "Djerba", city: "Médenine" },
  { label: "Monastir", city: "Monastir" },
  { label: "Mahdia", city: "Mahdia" },
  { label: "Tabarka", city: "Jendouba", delegation: "Tabarka" },
];
